export const environment = {
  production: false,
  firebase : {
    apiKey: 'AIzaSyAOtnx6h5emUS7z8MxYKQP0l_MQq2GArFs',
    authDomain: 'evalua-jardin.firebaseapp.com',
    databaseURL: 'https://evalua-jardin.firebaseio.com',
    projectId: 'evalua-jardin',
    storageBucket: 'evalua-jardin.appspot.com',
    messagingSenderId: '865857926608',
    appId: '1:865857926608:web:ca7eb598d89288276775d5',
    measurementId: 'G-2CB9GP1GFT'
  }
};
